import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import { css } from 'twin.macro';
import NavigationBar from '../reusableComponents/NavigationBar';
import { AiFillEdit } from 'react-icons/ai';
import { VscLoading } from 'react-icons/vsc';
import { Button } from 'react-bootstrap';
import { fetchWrapper } from '../../../_helpers/fetchWrapper';
import { toast } from 'react-toastify';
import LabelsAndCategoriesSettings from './Setting/LabelsAndCategoriesSettings';
import PublicGps from './PublicGps';

import { IoMdCall } from 'react-icons/io';
import { MdTextsms, MdLabelImportant, MdGpsFixed } from 'react-icons/md';

function Settings() {
	const [activeTab, setActiveTab] = useState('conference');
	const [settingsInfo, setSettingsInfo] = useState({});

	useEffect(() => {
		const getSettingsInfo = async () => {
			try {
				const response = await fetchWrapper.get('/config');
				setSettingsInfo({ conferenceTimeLimit: response?.conferenceTimeLimit, smsPerDay: response?.smsPerDay });
			} catch (err) {
				console.log(err);
			}
		};
		getSettingsInfo();
	}, []);

	let render;
	switch (activeTab) {
		case 'conference':
			render = (
				<>
					<div className="heading">
						<h3>Meeting</h3>
					</div>
					<div className="body">
						<SettingItem
							title={'Time Limit'}
							id={'conferenceTimeLimit'}
							value={settingsInfo.conferenceTimeLimit}
							settingsInfo={settingsInfo}
							setSettingsInfo={setSettingsInfo}
							unit={'mins'}
						/>
					</div>
				</>
			);
			break;
		case 'sms':
			render = (
				<>
					<div className="heading">
						<h3>SMS</h3>
					</div>
					<div className="body">
						<SettingItem
							title={'SMS'}
							lead="per person/ per day"
							id={'smsPerDay'}
							value={settingsInfo.smsPerDay}
							settingsInfo={settingsInfo}
							setSettingsInfo={setSettingsInfo}
							unit={'SMS'}
						/>
					</div>
				</>
			);
			break;
		case 'labels':
			render = (
				<>
					<div className="heading">
						<h3>Labels And Categories</h3>
					</div>
					<div className="body">
						<LabelsAndCategoriesSettings />
					</div>
				</>
			);
			break;
		case 'public_gps':
			render = (
				<>
					<div className="heading">
						<h3>Public Gps</h3>
					</div>
					<div className="body">
						<PublicGps />
					</div>
				</>
			);
			break;
		default:
			render = null;
	}

	return (
		<ContainerStyles>
			<div className="d-flex justify-content-between mb-4">
				<NavigationBar mainTabName="Settings" />
			</div>
			<StyledSettingsContainer>
				<StyledSettingsBar>
					<div
						className={`navItem ${activeTab === 'conference' ? 'active' : ''}`}
						onClick={() => setActiveTab('conference')}
					>
						<IoMdCall className="mr-2" />
						Meeting
					</div>
					<div
						className={`navItem ${activeTab === 'sms' ? 'active' : ''}`}
						onClick={() => setActiveTab('sms')}
					>
						<MdTextsms className="mr-2" />
						SMS
					</div>
					<div
						className={`navItem ${activeTab === 'labels' ? 'active' : ''}`}
						onClick={() => setActiveTab('labels')}
					>
						<MdLabelImportant className="mr-2" />
						Labels And Categories
					</div>
					<div
						className={`navItem ${activeTab === 'public_gps' ? 'active' : ''}`}
						onClick={() => setActiveTab('public_gps')}
					>
						<MdGpsFixed className="mr-2" />
						Public Gps Category
					</div>
				</StyledSettingsBar>
				<StyledSettingsArea>{render}</StyledSettingsArea>
			</StyledSettingsContainer>
		</ContainerStyles>
	);
}

export default Settings;

export const ContainerStyles = styled('div')`
	padding: 1rem 2rem;
`;
export const StyledSettingsContainer = styled.div`
	min-height: 90vh;
	display: flex;
`;
export const StyledSettingsBar = styled.div`
	background: white;
	flex: 1;
	max-width: 340px;
	margin: 1rem;
	padding: 1rem 0;
	border-radius: 5px;
	box-shadow: 3px 3px 5px 5px #d7d7d7;
	.navItem {
		padding: 2rem 1rem;
		border: 1px solid #dfdfdd;
		font-size: 1.8rem;
		border-top: none;
		cursor: pointer;
		display: flex;
		align-items: center;
		transition: background-color 200ms, color 200ms;
		color: #374d76;
		:hover {
			background-color: #71babb;
			color: white;
		}
	}
	.navItem.active {
		background-color: #50aeb0;
		color: white;
		font-weight: bold;
		letter-spacing: 1px;
	}
`;
export const StyledSettingsArea = styled.div`
	background: white;
	flex: 1;
	border-radius: 5px;
	margin: 1rem 1rem 1rem 1rem;
	box-shadow: 2px 2px 5px 5px #d7d7d7;
	.heading {
		background: #50aeb0;
		color: white;
		padding: 2rem;
		border-top-right-radius: 5px;
		border-top-left-radius: 5px;
		font-size: 1.8rem;
		font-weight: bold;
		letter-spacing: 1px;
	}
	.body {
		padding: 2rem;
	}
`;

const StyledSettingItem = styled.div`
	border: 1px solid #bebebe;
	border-radius: 5px;
	overflow: hidden;
	margin-bottom: 1rem;

	.head {
		padding: 2rem;
		display: flex;
		justify-content: space-between;
		.title {
			display: flex;
			width: 40%;
			justify-content: space-between;
		}
	}
	.body {
		background-color: #f9f9f9;
	}
`;

const SettingItem = ({ title, id, lead, value, unit, settingsInfo, setSettingsInfo }) => {
	const [itemValue, setItemValue] = useState(value);
	const [loading, setLoading] = useState(false);
	useEffect(() => {
		setItemValue(value);
	}, [value]);
	const [isOnChange, setIsOnChange] = useState(false);
	const handleChangeToggle = () => {
		setIsOnChange(!isOnChange);
	};

	const handleUpdate = async () => {
		try {
			setLoading(true);
			const body = {
				[id]: itemValue,
			};
			await fetchWrapper.patch('/config', body);
			setSettingsInfo({
				...settingsInfo,
				[id]: itemValue,
			});
			toast.success('Update Successful');
			setLoading(false);
			setIsOnChange(false);
		} catch (error) {
			toast.error('Update Failed!, Please try again later');
			console.log(error);
			setLoading(false);
		}
	};
	return (
		<StyledSettingItem>
			<div className="head">
				<div className="title">
					<h4 className="text-left">
						{title}
						{lead && <span className="lead">{lead}</span>}
					</h4>
					<h4 className="text-right">
						<input
							key={id}
							type="number"
							css={css`
								width: 100px;
								text-align: center;
								padding: 0.5rem;
								border: none;
								border-bottom: 1px solid black;
							`}
							onChange={(e) => {
								setItemValue(e.target.value);
							}}
							value={itemValue}
							disabled={loading || !isOnChange}
						/>{' '}
						{unit}
					</h4>
				</div>
				{isOnChange && (
					<Button disabled={loading} onClick={handleUpdate}>
						{loading ? <VscLoading className="spin" /> : 'Update'}
					</Button>
				)}

				<Button
					variant={isOnChange ? 'danger' : 'outline-danger'}
					className="cursor-pointer "
					onClick={handleChangeToggle}
				>
					<AiFillEdit fontSize="24" /> Change
				</Button>
			</div>
		</StyledSettingItem>
	);
};
